import { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";

export const useEmailAddressVerification = () => {
  const navigate = useNavigate();

  const [otpState, setOtpState] = useState({
    otp: "",
    status: "normal",
    errorMessage: "",
  });
  const [searchParams] = useSearchParams();

  const handleChangeValue = (e) => setOtpState({ ...otpState, otp: e });

  const handleSubmitOtp = () => {
    if (!otpState.otp) {
      setOtpState({
        ...otpState,
        status: "error",
        errorMessage: "OTP cannot be empty.",
      });
    }

    if (!otpState.otp < 4) {
      setOtpState({
        ...otpState,
        status: "error",
        errorMessage: "OTP incorrect.",
      });
    }

    navigate("/dashboard");
  };

  const handleBackButton = () => {
    navigate(
      searchParams.get("type") === "login"
        ? "/login/mobile-number"
        : "/register/mobile-number"
    );
  };

  return {
    searchParams,
    handleBackButton,
    handleChangeValue,
    handleSubmitOtp,
    otpState,
  };
};
